import ENVIRONMENTS from 'constants/enviroments';
import { isTicketSalesTrackedPath } from 'helpers/ticketSalesTracking';

export const GTM_SCRIPT_ID = 'google-tag-manager';
export const GTM_SCRIPT_URL = 'https://www.googletagmanager.com/gtm.js';

type DataLayerEvent = Record<string, unknown>;
type WindowWithDataLayer = Window & { dataLayer?: DataLayerEvent[] };

/**
 * ID do container do Google Tag Manager (REACT_APP_GTM_CONTAINER_ID, ex.: GTM-XXXXXXX).
 * Definido apenas nos clientes que usam o serviço (hoje: CatSul). Vazio = desativado.
 */
export const getGtmContainerId = () =>
  (ENVIRONMENTS.GOOGLE_TAG_MANAGER.CONTAINER_ID || '').trim();

export const isGtmEnabled = () => Boolean(getGtmContainerId());

/**
 * O monitoramento cobre apenas o e-commerce (venda de passagens),
 * nunca o back-office (/bdos) ou os demais módulos do mesmo domínio.
 */
export const isGtmTrackedPath = isTicketSalesTrackedPath;

/**
 * Equivalente em runtime ao snippet oficial do GTM ("cole no mais alto possível
 * no <head>"): inicializa o dataLayer com o evento gtm.js e injeta
 * <script async src="https://www.googletagmanager.com/gtm.js?id=GTM-..."> como
 * primeiro filho do <head>, uma única vez.
 *
 * O trecho <noscript> do snippet não é injetado: criado via DOM ele não tem
 * efeito (o JS já está rodando) e o iframe ns.html poderia gerar hit duplicado.
 * Como o e-commerce é um SPA React, sem JS nada funciona de qualquer forma.
 *
 * Retorna true quando o script foi (ou já estava) injetado.
 */
export const loadGtmScript = (): boolean => {
  const containerId = getGtmContainerId();
  if (!containerId) return false;
  if (document.getElementById(GTM_SCRIPT_ID)) return true;

  const w = window as WindowWithDataLayer;
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  const script = document.createElement('script');
  script.id = GTM_SCRIPT_ID;
  script.async = true;
  script.src = `${GTM_SCRIPT_URL}?id=${encodeURIComponent(containerId)}`;
  document.head.insertBefore(script, document.head.firstChild);
  return true;
};
